import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { FormGroup } from '@angular/forms'
import { LiveTransfer, Transfer } from 'src/lib/entity/transfer'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { saveAs } from 'file-saver'
import * as encoding from 'encoding-japanese'
import { ToastrService } from 'ngx-toastr'

@Component({
  selector: 'transfer-index',
  templateUrl: './transfer-index.component.html',
  styleUrls: [
    '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss',
    './transfer-index.component.scss',
  ],
})
export class TransferIndexComponent implements OnInit {
  formGroup: FormGroup
  transfers: Transfer[] | 'NOT_FOUND'
  liveTransfers: LiveTransfer[] | 'NOT_FOUND'
  selectedMonth: string
  tableStatus: 'loading' | 'completed' | 'failed' | 'empty'
  invalidCsvDl: boolean
  selectedOption: 'BY_MAGAZINE_ID' | 'BY_LIVE_ID' = 'BY_MAGAZINE_ID'
  byLiveId = false

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const date = new Date()
    this.selectedMonth =
      date.getFullYear() +
      '-' +
      (date.getMonth() + 1).toString().padStart(2, '0')
    if (this.route.snapshot.queryParamMap.get('yearMonth')) {
      this.selectedMonth = this.route.snapshot.queryParamMap.get('yearMonth')
    }
    this.loadTransfers()
    this.invalidCsvDl = false
    if (this.route.snapshot.queryParamMap.get('yearMonth')) {
      this.selectedMonth = this.route.snapshot.queryParamMap.get('yearMonth')
    }
  }

  switchTransfers(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        yearMonth: this.selectedMonth,
        byLiveId: this.byLiveId,
      },
    })
    this.loadTransfers()
  }

  public loadTransfers(): void {
    this.tableStatus = 'loading'

    if (this.byLiveId) {
      MagliveApiClient.fetchLiveTransfers(this.selectedMonth).subscribe((value) => {
        if (value !== 'NOT_FOUND') {
          this.liveTransfers = value.items
          if (this.liveTransfers.length) this.tableStatus = 'completed'
          else this.tableStatus = 'empty'
        } else {
          this.liveTransfers = value
          this.tableStatus = 'failed'
        }
      })
    } else {
      MagliveApiClient.fetchTransfers(this.selectedMonth).subscribe((value) => {
        if (value !== 'NOT_FOUND') {
          this.transfers = value.items
          if (this.transfers.length) this.tableStatus = 'completed'
          else this.tableStatus = 'empty'
        } else {
          this.transfers = value
          this.tableStatus = 'failed'
        }
      })
    }
  }

  exportCsvTransfer() {
    this.invalidCsvDl = true
    const exportMethod = this.byLiveId ? MagliveApiClient.exportCsvLiveTransfer : MagliveApiClient.exportCsvTransfer

    exportMethod(this.selectedMonth).subscribe(
      (value) => {
        if (value === 'NOT_FOUND') {
          this.invalidCsvDl = false
          this.toastr.error('エラーが発生しました。')
          return
        }
        if (!value.fileData.length) {
          this.invalidCsvDl = false
          this.toastr.error('振込データが存在していません。')
          return
        }

        const fileName = value.fileName
        const fileData = value.fileData

        const unicodeList = []
        for (let i = 0; i < fileData.length; i++) {
          unicodeList.push(fileData.charCodeAt(i))
        }

        const shiftJisCodeList = encoding.convert(
          unicodeList,
          'SJIS',
          'UNICODE'
        )
        const unit8Array = new Uint8Array(shiftJisCodeList)

        const blob = new Blob([unit8Array], { type: 'text/csv' })

        saveAs(blob, fileName)
        this.invalidCsvDl = false
      },
      (error) => {
        this.invalidCsvDl = false
        console.log(error)
      }
    )
  }

  /**
   * ラジオボタンの変更イベントハンドラ
   * 選択されたラジオボタンに基づいてデータを差し替える
   */
  onRadioButtonChange(): void {
    switch (this.selectedOption) {
      case 'BY_MAGAZINE_ID':
        this.byLiveId = false
        this.switchTransfers()
        break;
      case 'BY_LIVE_ID':
        this.byLiveId = true
        this.switchTransfers()
        break
      default:
        break
    }
  }
}
